import React from 'react';
import { IIconProps } from './utils';

export const SafetyGoggles = ({
  fill = 'currentColor',
  height = 18,
  width = 18,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 18 18" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M6 3L4.60339 3.93108C4.05018 4.29988 3.63516 4.84201 3.42353 5.4723L1.60944 10.875C1.53873 11.0691 1.5 11.2798 1.5 11.5V12M12 3L13.3966 3.93108C13.9498 4.29988 14.3648 4.84201 14.5765 5.4723L16.3906 10.875C16.4613 11.0691 16.5 11.2798 16.5 11.5V12M16.5 12C16.5 10.3431 15.1569 9 13.5 9H4.5C2.84315 9 1.5 10.3431 1.5 12M16.5 12C16.5 13.6569 15.1569 15 13.5 15C12.3644 15 11.3761 14.369 10.8667 13.4385C10.4689 12.7118 9.82843 12 9 12C8.17157 12 7.53109 12.7118 7.13329 13.4385C6.6239 14.369 5.63564 15 4.5 15C2.84315 15 1.5 13.6569 1.5 12"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
